export default "__VITE_ASSET__CXxVyS1P__"